export enum AppFeature {
  CreateSimulation,
  CreateQuittance,
  CreateCollectiveContract,
  CreateContact,
}
